import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InputCustomerTenantDialog } from "./InputCustomerTenantDialog";
import { TenantForm, useRegisterTenantButton } from "./useRegisterTenantButton";
import { ConfirmDialog } from "./ConfirmDialog";

interface Props {
  customerTenantId: string;
  contractorId: string;
  formdata: TenantForm;
  onAfterRegister: () => void;
}

/**
 * お客様テナントの変更ボタンのコンポーネントです。
 *
 * @returns お客様テナント追加ボタンのコンポーネント
 */
export const UpdateTenantButton = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  const {
    inputDialogOpen,
    confirmDialogOpen,
    tenantFormData,
    onClick,
    onConfirm,
    onInputCancel,
    onRegister,
    onConfirmCancel,
  } = useRegisterTenantButton(props.customerTenantId, props.contractorId, props.onAfterRegister);

  return (
    <>
      <Button variant="contained" onClick={onClick}>
        {t("admin.updateButton")}
      </Button>

      {/* 入力ダイアログ */}
      <InputCustomerTenantDialog
        open={inputDialogOpen}
        isEdit
        formData={props.formdata}
        id={props.customerTenantId}
        acceptButtonName={t("common.updateButton")}
        onConfirm={onConfirm}
        onCancel={onInputCancel}
      />

      {/* 確認ダイアログ */}
      <ConfirmDialog
        open={confirmDialogOpen}
        title={t("admin.confirmUpdateCustomerTenant")}
        formData={tenantFormData}
        acceptButtonName={t("common.updateButton")}
        onRegister={onRegister}
        onCancel={onConfirmCancel}
      />
    </>
  );
};
